{
  "BackToAllBuilders": "back to all builders",
  "Target": "Target",
  "Step2": "Step 2 - Advisors",

  "AboutThisBuilder": "About this Builder",
  "RebelSkillsGained": "Rebel Skills Gained",
  "next": "next",

  "Review": "Review",
  "ProfilePreview": "Profile Preview",
  "challengeReviewPhrase1": "Go back and answer some questions before you can see them here.",
  "published": "published",
  "WhoCanSeeThis": "Who can see this?",
  "NothingToPublishYet": "There is nothing to publish yet.",
  "TeamOnly": "Team Only",
  "MyEvents": "My Events",
  "Everyone": "Everyone",
  "Publish": "Publish",

  "addOption": "add option",
  "challengeTopicInputPlaceholder": "add ideas, scribbles, schemes, mindwarpping realizations here",
  "HeadsUp": "Heads up",
  "LastSaved": "Last saved",
  "by": "by",
  "saving": "saving...",
  "save": "save",
  "CannotSave": "Cannot save. Please review your team's changes first.",
  "SomeoneHasMadeChanges": "has made changes to this topic you are currently working on.",
  "challengeTopicPhrasePart1": "Please incorporate",
  "challengeTopicPhrasePart2": "changes in your work and",
  "challengeTopicPhrasePart3": "save work below",
  "or": "or",
  "challengeTopicPhrase2Part1": "Accept changes and",
  "use": "use",
  "changes": "changes",
  "SaveWorkBelow": "save work below",
  "BeSureNotToOverwrite": "has made changes to this. Be careful not to overwrite important work.",
  "ConfirmLeavingPage": "Are you sure you want to leave this page? Any unsaved work will be lost!",
  "backToTopics": "back to topics",
  "skipToAnswer": "skip to answer",
  "Section": "Section",
  "SectionName": "Section Name",
  "AddSectionContentHere": "add section content here",
  "GotItNext": "Got it, next",
  "SomeoneElseWorkingOnThis": "is also working on this question.",
  "SomeoneElseWorkingOnThisBuilder": " are also working on this builder.",

  "rebelMap": "C.O.R.E. rebelMap",
  "OpenAs": "Open as",
  "IntroToTarget": "Intro to Target",
  "Answer": "Answer",
  "OnTrack": "On Track",
  "switchTracks": "switch tracks",
  "nextTrack": "next track",
  "Progress": "Progress",
  "NoTrackSelected": "No Track Selected",
  "SelectTrack": "select track",
  "Builders": "Builders",
  "DifficultyLevel": "difficulty level",
  "JumpBackIn": "Jump back in...",
  "Differentation": "Differentation / Disruption",
  "BetaProjectPhrase1": "Thanks for taking part of RebelBase Beta!",
  "BetaProjectPhrase2Part1": "You probably already notice our new look (we accept compliments",
  "BetaProjectPhrase2Part2": "But we’ve changed more than just the layout. While you've been out on your various missions, back at the base we’ve worked tirelessly to create a more interactive, intuitive, and illuminating experience.",
  "BetaProjectPhrase2Part3": " So here’s thanks to all of the beta testers for providing feedback on which the new Rebel experience is based, so…",
  "WelcomeToRebelBase": "Welcome to RebelBase 1.0.",
  "OneImportantThing": "One important thing.",
  "BetaProjectPhrase3": "To migrate your beta project information, read this",
  "BetaProjectPhrase3Part1": "Since we made significant changes to the challlenges and questions, this migration will not be perfectly matched. There will be some data loss. Contact us for more info.",
  "OrPreferToStartFresh": "Or if you’d prefer to start fresh:",
  "BetaProjectPhrase4": " You will get the new challenges but not your old data. We cannot undo this.",
  "CopyThat": "Copy that",
  "StartFresh": "Let's start fresh",
  "tracks": "tracks",
  "subject": "subject",
  "SeeAllBuilders": "see all builders"
}
